import { Component } from '@angular/core'
import { Router, RouterOutlet, RouterModule } from '@angular/router'
import { MatTabsModule } from '@angular/material/tabs'
import { TabsComponent } from '../../shared/components/tabs/tabs.component'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        MatTabsModule,
        RouterModule,
        RouterOutlet,
        TabsComponent
    ],
    templateUrl: './db.component.html'
})
export class DBComponent {
  constructor(
    private router: Router,
    private title: Title
  ) {}

  links = [
    { location: 'atscore', label:'AT Score' },
    { location: 'players', label: 'Atleti Metrics' },
    { location: 'season', label: 'Player Metrics' },
    { location: 'teams', label: 'Team Data' }
  ]
  activeLink = this.links[0]

  ngOnInit() {
    this.title.setTitle('Atlético Stats - Base de datos')
    let href = this.router.url
    const index = this.links.map(e => e.location).indexOf(href.substring(4))
    this.activeLink = this.links[index]
  }
}

